import { render, staticRenderFns } from "./dataset-documentation.vue?vue&type=template&id=f3ac50ee"
import script from "./dataset-documentation.vue?vue&type=script&lang=js"
export * from "./dataset-documentation.vue?vue&type=script&lang=js"
import style0 from "./dataset-documentation.vue?vue&type=style&index=0&id=f3ac50ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports